// used for special hours, gx special hours and labels
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { MultiLineTextCellLocalStoreService } from './multi-line-text-cell-local-store.service';
import { JoinArrayPipe } from '../../../../../pipes/join-array.pipe';
import { SplitStringPipe } from '../../../../../pipes/split-string.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'app-multi-line-text-cell',
    templateUrl: './multi-line-text-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MultiLineTextCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, NgxSkeletonLoaderModule, SplitStringPipe, JoinArrayPipe]
})
export class MultiLineTextCellComponent extends AgCellRendererComponent {

  public viewModel$ = this.localStore.viewModel$;
  constructor(protected localStore: MultiLineTextCellLocalStoreService) {
    super(localStore);
  }
}
